/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Created_AtInputs */

const en_admin_categories_created_at = /** @type {(inputs: Admin_Categories_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Admin_Categories_Created_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_created_at = /** @type {((inputs?: Admin_Categories_Created_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Created_AtInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_created_at(inputs)
});
export { admin_categories_created_at as "admin.categories.created_at" }